import { render, staticRenderFns } from "./FacebookActionForm.vue?vue&type=template&id=0af50750&scoped=true"
import script from "./FacebookActionForm.vue?vue&type=script&lang=js"
export * from "./FacebookActionForm.vue?vue&type=script&lang=js"
import style0 from "./FacebookActionForm.vue?vue&type=style&index=0&id=0af50750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af50750",
  null
  
)

export default component.exports